(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bandido-gift-cart-guard"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.BandidoGiftGuard) return;
    const initial = document.getElementById('BandidoGiftInitialState');
    const messages = document.getElementById('BandidoGiftMessages');
    if (!initial || !messages) return;
    const texts = JSON.parse(messages.textContent);
    const root = window.Shopify?.routes?.root || '/';
    const cartUrl = root + 'cart';
    const readSession = (key) => { try { return sessionStorage.getItem(key); } catch { return null; } };
    const writeSession = (key, value) => { try { sessionStorage.setItem(key, value); } catch {} };
    let current = JSON.parse(initial.textContent);
    let busy = false;
    let checkoutAllowed = false;
    let refreshTimer;
    let uncertain = readSession('bandidoGiftUncertain') === '1';
    const markUncertain = (value) => {
      uncertain = value;
      writeSession('bandidoGiftUncertain', value ? '1' : '0');
    };
    const notice = (message) => {
      const box = document.getElementById('BandidoGiftNotice');
      box.querySelector('[data-gift-notice-text]').textContent = message;
      box.hidden = false;
    };
    const classify = (state) => {
      if (state?.currency !== 'EUR' || !Array.isArray(state.items) || !Number.isInteger(state.total)) throw new Error(texts.error);
      const gifts = state.items.filter((item) => item.promotion === true);
      const unknown = state.items.some((item) => item.managed && !item.promotion);
      const excluded = state.items.filter((item) => item.promotion || item.giftCard);
      if (state.items.some((item) => !Number.isInteger(item.price) || !Number.isInteger(item.quantity))) throw new Error(texts.error);
      const paid = Math.max(0, state.total - excluded.reduce((sum, item) => sum + item.price, 0));
      const gift = gifts[0];
      const contentsValid = gift && Array.isArray(gift.components) && gift.components.length === 5 && new Set(gift.components.map((c) => c.product)).size === 5 && gift.components.every((c) => c.quantity === 1);
      const valid = !unknown && gifts.length === 1 && gift.quantity === 1 && gift.price === 0 && paid >= 15000 && contentsValid;
      return { gifts, unknown, paid, valid };
    };
    const remember = (state) => {
      current = state;
      const checked = classify(state);
      document.documentElement.classList.toggle('bandido-gift-in-cart', checked.gifts.length > 0 || checked.unknown || uncertain);
      document.dispatchEvent(new CustomEvent('bandido:gift-state', { detail: checked }));
      return checked;
    };
    const request = async (path, body) => {
      const options = { credentials: 'same-origin', cache: 'no-store' };
      if (body) Object.assign(options, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      const response = await fetch(root + path, options);
      if (!response.ok) throw new Error(texts.error);
      return response.json();
    };
    const fresh = async () => {
      const response = await request('?sections=bandido-gift-cart-state');
      const html = response['bandido-gift-cart-state'];
      if (typeof html !== 'string') throw new Error(texts.error);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const node = doc.querySelector('[data-bandido-gift-cart-state]');
      if (!node) throw new Error(texts.error);
      const state = JSON.parse(node.textContent);
      remember(state);
      return state;
    };
    const removeGift = async (variant) => {
      const state = await fresh();
      const gifts = classify(state).gifts.filter((item) => Number(item.variant) === Number(variant));
      for (const item of gifts) await request('cart/change.js', { id: item.key, quantity: 0 });
      const after = await fresh();
      if (classify(after).gifts.some((item) => Number(item.variant) === Number(variant))) throw new Error(texts.review);
      markUncertain(false);
      remember(after);
    };
    const withLock = async (action) => {
      if (busy) throw new Error(texts.review);
      busy = true;
      try {
        if (navigator.locks) return await navigator.locks.request('bandido-gift-cart', action);
        return await action();
      } finally { busy = false; }
    };
    const add = async (variant, expectedProducts) => withLock(async () => {
      const before = classify(await fresh());
      if (before.gifts.length || before.unknown) throw new Error(texts.already);
      if (before.paid < 15000) throw new Error(texts.minimum);
      if (expectedProducts.length !== 5 || new Set(expectedProducts).size !== 5) throw new Error(texts.error);
      writeSession('bandidoGiftTouched', '1');
      let attempted = false;
      try {
        attempted = true;
        markUncertain(true);
        document.documentElement.classList.add('bandido-gift-in-cart');
        await request('cart/add.js', { items: [{ id: variant, quantity: 1, properties: { _bandido_gift: 'v1' } }] });
        const after = classify(await fresh());
        const gift = after.gifts[0];
        const actual = gift?.components.map((component) => Number(component.product)).sort().join(',');
        const expected = expectedProducts.map(Number).sort().join(',');
        if (!after.valid || Number(gift.variant) !== Number(variant) || actual !== expected) throw new Error(texts.notFree);
        markUncertain(false);
        return true;
      } catch (error) {
        if (attempted) {
          try { await removeGift(variant); }
          catch { notice(texts.review); throw new Error(texts.review); }
        }
        throw error;
      }
    });
    const reconcile = async () => withLock(async () => {
      const checked = classify(await fresh());
      if (checked.unknown) { notice(texts.review); return false; }
      if (!checked.gifts.length || checked.valid) {
        markUncertain(false);
        remember(current);
        return true;
      }
      for (const gift of checked.gifts) await removeGift(gift.variant);
      notice(texts.removed);
      writeSession('bandidoGiftNotice', texts.removed);
      location.assign(cartUrl);
      return false;
    });
    const guardCheckout = async (event, proceed) => {
      if (checkoutAllowed) return;
      const prior = classify(current);
      if (!prior.gifts.length && !prior.unknown && !uncertain && !busy && !readSession('bandidoGiftTouched')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      try {
        if (busy) { notice(texts.review); return; }
        if (!await reconcile()) return;
        checkoutAllowed = true;
        proceed();
        setTimeout(() => { checkoutAllowed = false; }, 0);
      } catch {
        const latest = classify(current);
        if (!latest.gifts.length && !latest.unknown && !uncertain && !busy) {
          checkoutAllowed = true;
          proceed();
          setTimeout(() => { checkoutAllowed = false; }, 0);
        } else notice(texts.review);
      }
    };
    document.addEventListener('submit', (event) => {
      if (event.submitter?.name !== 'checkout') return;
      guardCheckout(event, () => event.target.requestSubmit(event.submitter));
    }, true);
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link) return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || !/\/(checkout|checkouts)(\/|$)/.test(url.pathname)) return;
      guardCheckout(event, () => location.assign(url.href));
    }, true);
    const schedule = () => {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(() => {
        if (busy) return;
        reconcile().catch(() => { if (classify(current).gifts.length) notice(texts.review); });
      }, 300);
    };
    window.BandidoGiftGuard = { add, fresh, classify, reconcile, notice, get busy() { return busy; }, get uncertain() { return uncertain; } };
    remember(current);
    document.dispatchEvent(new CustomEvent('bandido:gift-ready'));
    const previousNotice = readSession('bandidoGiftNotice');
    if (previousNotice) {
      notice(previousNotice);
      try { sessionStorage.removeItem('bandidoGiftNotice'); } catch {}
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    window.addEventListener('pageshow', () => { if (classify(current).gifts.length || uncertain) schedule(); });
  })();
  } catch(e) { console.error(e); }
})();

})();
